import api from 'api/base';

const getCampaigns = () => {
  return api.get('v4/navigation/campaigns');
};

export default {
  getCampaigns,
};
